import React from 'react';
import DecisionTreeExpandedContextProvider from '../DecisionTreeExpandedContext/DecisionTreeExpandedContextProvider';
import DecisionTreeInfoContextProvider from '../DecisionTreeInfoContext/DecisionTreeInfoContextProvider';
import { DecisionTreePreviewContextProvider } from '../DecisionTreePreviewContext';
import DecisionTreeResultContextProvider from '../DecisionTreeResultContext/DecisionTreeResultContextProvider';
import DecisionTreeRunContextProvider from '../DecisionTreeRunContext/DecisionTreeRunContextProvider';
import DecisionTreeSequenceTransitionContextProvider from '../DecisionTreeSequenceTransitionContext/DecisionTreeSequenceTransitionContextProvider';

export default function DecisionTreeContextProvider({ children }: { children: React.ReactNode }) {
  return (
    <DecisionTreeRunContextProvider>
      <DecisionTreePreviewContextProvider>
        <DecisionTreeInfoContextProvider>
          <DecisionTreeExpandedContextProvider>
            <DecisionTreeResultContextProvider>
              <DecisionTreeSequenceTransitionContextProvider>
                {children}
              </DecisionTreeSequenceTransitionContextProvider>
            </DecisionTreeResultContextProvider>
          </DecisionTreeExpandedContextProvider>
        </DecisionTreeInfoContextProvider>
      </DecisionTreePreviewContextProvider>
    </DecisionTreeRunContextProvider>
  );
}
